// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer {\n  height: 50px;\n  height: 50px;\n  /* background-color: aqua; */\n  justify-content: center;\n  align-content: center;\n  display: flex;\n}", ""]);
// Exports
module.exports = exports;
